(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranimahal-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setupContact = () => {
    document.querySelectorAll('[data-rm-contact]').forEach(section => {
      if (section.dataset.rmReady) return;
      section.dataset.rmReady = 'true';
      const select = section.querySelector('[data-rm-design]');
      const textarea = section.querySelector('textarea[name="contact[body]"]');
      const selected = section.querySelector('[data-rm-selected]');
      const initial = Array.from(selected.childNodes).map(node => node.cloneNode(true));
      const designs = Array.from(section.querySelector('[data-rm-designs]').content.querySelectorAll('[data-design-code]'));
      let generatedMessage = '';
      const update = (code, changeMessage) => {
        const design = designs.find(item => item.dataset.designCode === code);
        const nextMessage = design ? section.dataset.message.replace('[design]', design.dataset.designTitle) : '';
        selected.replaceChildren(...(design ? [design.cloneNode(true)] : initial.map(node => node.cloneNode(true))));
        if (changeMessage && (!textarea.value.trim() || textarea.value === generatedMessage)) textarea.value = nextMessage;
        generatedMessage = nextMessage;
      };
      const code = new URLSearchParams(location.search).get('design');
      const option = Array.from(select.options).find(item => item.dataset.code === code);
      if (option) select.value = option.value;
      update(select.selectedOptions[0]?.dataset.code, true);
      select.addEventListener('change', () => {
        const selectedCode = select.selectedOptions[0]?.dataset.code;
        update(selectedCode, true);
        const url = new URL(location.href);
        selectedCode ? url.searchParams.set('design', selectedCode) : url.searchParams.delete('design');
        history.replaceState(null, '', url);
      });
      section.querySelector('[data-rm-form-status]')?.focus();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupContact, { once:true }); else setupContact();
  document.addEventListener('shopify:section:load', setupContact);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranimahal-enquiry-context"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const populateEnquiry = () => {
      const code = new URLSearchParams(window.location.search).get('design');
      if (!code) return;
      document.querySelectorAll('.rm-enquiry-context').forEach(context => {
        const look = Array.from(context.querySelector('template').content.querySelectorAll('[data-design-code]')).find(item => item.dataset.designCode === code);
        const textarea = document.querySelector('textarea[name="contact[body]"]');
        if (!look || !textarea) return;
        const title = look.dataset.designTitle;
        context.querySelector('.rm-enquiry-context__label').textContent = context.dataset.enquiryIntro.replace('[design]', title);
        context.hidden = false;
        if (!textarea.value.trim()) {
          textarea.value = context.dataset.enquiryMessage.replace('[design]', title);
          textarea.dispatchEvent(new Event('input', { bubbles: true }));
        }
        const form = textarea.form;
        if (form && !form.querySelector('[data-ranimahal-design]')) {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'contact[Design]';
          field.value = title;
          field.dataset.ranimahalDesign = 'true';
          form.appendChild(field);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', populateEnquiry, { once: true });
    else populateEnquiry();
    document.addEventListener('shopify:section:load', populateEnquiry);
  })();

  } catch(e) { console.error(e); }
})();
})();
